// extracted by mini-css-extract-plugin
export var deleteIcon = "_ph-5";
export var deleteOption = "_ph-3";
export var divider = "_ph-2";
export var downloadIcon = "_ph-4";
export var drawer = "_ph-0";
export var drawerFooter = "_ph-6";
export var drawerOpen = "_ph-1";
export var highlighted = "_ph-7";
export var lighterHighlight = "_ph-8";